

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

import { Rule, CaseRule, TemplateDetails } from "@/types"

// @ts-ignore
import draggable from "vuedraggable"
import vSelect from "vue-select"

const setup = namespace("setup")

@Component({
	components: {
		draggable,
		"v-select": vSelect
	}
})
export default class TemplateRuleSetup extends Vue {
	@Prop()
	public template!: TemplateDetails

	@Prop({ type: Boolean, default: true })
	public canEdit!: boolean;

	@setup.Action loadRules!: () => Promise<any[]>;
	@setup.State rules!: Rule[];

	public async mounted () {
		await this.loadRules()
	}

	public get columns () {
		return [
			{
				key: "handle",
				label: ""
			},
			{
				label: "Title"
			},
			{
				key: "runOnCase",
				label: "Run on Case"
			},
			{
				key: "runOnRecord",
				label: "Run On Record"
			},
			{
				key: "buttons",
				label: ""
			}
		]
	}

	public get dragOptions () {
		return {
			animation: 200,
			group: "rules",
			disabled: false,
			ghostClass: "ghost"
		}
	}

	public addRule () {
		this.$emit("addRule")
	}

	public removeRule (item: CaseRule) {
		if (!this.template) {
			return
		}

		this.template!.rules.removeWhere(a => a === item)
	}

	private onRuleSelected () {
		this.$emit("ruleSelected")
	}
}

